import type { AiService } from '@/context/services/ai_service_setting/type';
import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from '../../../styles.module.scss';
import { ServiceRow } from './ServiceRow';

const cx = classnames.bind(styles);

type Props = {
  services: AiService[];
  renderValue: (service: AiService) => ReactNode;
};

export const ServiceRows: FC<Props> = ({ services, renderValue }) => (
  <div className={cx(styles['bodySectionContainer'])}>
    {services.map((service) => (
      <ServiceRow key={service.service_type} service={service}>
        {renderValue(service)}
      </ServiceRow>
    ))}
  </div>
);

ServiceRows.displayName = 'ApAiServiceSettingsServiceRows';
